import React from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { FISCAL_PERIOD_TYPE } from 'utils/fiscalPeriods';
import messages from './messages';
import { get, isEmpty } from 'lodash';

const FiscalPeriodLabel = ({ details, startDate, endDate, pointInTime, bookingDate }) => {
    const { type, name, year } = details || {};

    let messageName = type === FISCAL_PERIOD_TYPE.CUSTOM ? 'customPeriodLabel' : 'predefinedPeriodLabel';
    if (!isEmpty(get(bookingDate, 'start'))) {
        if (isEmpty(startDate)) {
            messageName = 'bookingDatePeriodOnly';
        } else {
            messageName = `${messageName}BookingDate`;
        }
    }
    return (
        <FormattedMessage
            {...messages[messageName]}
            values={{
                name,
                year,
                startDate: startDate && (
                    <FormattedDate value={startDate} weekday="short" day="2-digit" month="short" year="2-digit" />
                ),
                endDate: endDate && (
                    <FormattedDate value={endDate} weekday="short" day="2-digit" month="short" year="2-digit" />
                ),
                showPointInTime: pointInTime != null,
                pointInTime: pointInTime && (
                    <FormattedDate value={pointInTime} day="2-digit" month="short" year="numeric" />
                ),
                bookingStart: get(bookingDate, 'start') && (
                    <FormattedDate
                        value={get(bookingDate, 'start')}
                        weekday="short"
                        day="2-digit"
                        month="short"
                        year="2-digit"
                    />
                ),
                bookingEnd: get(bookingDate, 'end') && (
                    <FormattedDate
                        value={get(bookingDate, 'end')}
                        weekday="short"
                        day="2-digit"
                        month="short"
                        year="2-digit"
                    />
                ),
                smaller: (chunk) => <span style={{ fontSize: '0.75em' }}>{chunk}</span>,
            }}
        />
    );
};

export default FiscalPeriodLabel;
